import { FlexRow, Panel, Text, Avatar, FlexSpacer } from '@epam/promo';
import { FlexCell } from '@epam/uui-components';
import { PermissionControl } from 'components/permissions/PermissionControl';
import { useUserStore } from 'store/user';
import { ADDED_STATUS, USER_ROLE } from 'models/user.model';
import { PermissionCardProps } from './PermissionCard.model';
import css from './PermissionCard.module.scss';

export const PermissionCard = ({ user }: PermissionCardProps) => {
  const currentUser = useUserStore((state) => state.user);
  const fullName = user.firstName ? `${user.firstName} ${user.lastName}` : '';
  const isInactive =
    user.status === ADDED_STATUS && user.firstName && user.lastName;
  const isCurrentUser = currentUser?.email === user.email;

  return (
    <FlexRow cx={css['permission-card']}>
      <Avatar
        alt={user.email}
        cx={isInactive && css['permission-card__inactive']}
        img={user.avatar}
        size="30"
      />
      <Panel
        cx={`${css['permission-card__name']} ${
          isInactive && css['permission-card__inactive']
        }`}>
        <Text color="gray80" size="24">
          {fullName} {isCurrentUser ? '(You)' : ''}
        </Text>
        <Text color="gray60" size="18">
          {user.email}
        </Text>
      </Panel>
      <FlexSpacer />
      <FlexCell cx={css['permission-card__picker']}>
        {user.email !== currentUser?.email ? (
          <PermissionControl user={user} />
        ) : (
          <Text color="gray80" cx={css['permission-card__role']} size="30">
            {USER_ROLE[user.role]}
          </Text>
        )}
      </FlexCell>
    </FlexRow>
  );
};
